/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CompetenceCompetenceidLangsId200,
  GetApiV1CompetenceCompetenceidLangsId401,
  GetApiV1CompetenceCompetenceidLangsId404,
  GetApiV1CompetenceCompetenceidLangsId500,
  GetApiV1CompetenceCompetenceidLangsIdPathParams,
  GetApiV1CompetenceCompetenceidLangsIdQueryResponse,
} from "../../types/competenceIdiomasController/GetApiV1CompetenceCompetenceidLangsId.ts";
import { competenceLangViewModelSchema } from "../competenceLangViewModelSchema.ts";

export const getApiV1CompetenceCompetenceidLangsIdPathParamsSchema = z.object({
  competenceId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CompetenceCompetenceidLangsId200Schema = z.lazy(
  () => competenceLangViewModelSchema,
) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CompetenceCompetenceidLangsId401Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CompetenceCompetenceidLangsId404Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CompetenceCompetenceidLangsId500Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsId500>;

export const getApiV1CompetenceCompetenceidLangsIdQueryResponseSchema = z.lazy(
  () => getApiV1CompetenceCompetenceidLangsId200Schema,
) as unknown as ToZod<GetApiV1CompetenceCompetenceidLangsIdQueryResponse>;
